import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { TypedComponentRendering } from '@core/jss-models';
import type {
  ProgressiveFormContainerFields,
  ScDynamicProgressiveFormConfig,
} from '@innogy/shared/progressive-form/sitecore/models';

import { renderingMapper } from './mapper';
import { ProgressiveFormContainerComponent } from '../progressive-form-container/progressive-form-container.component';

@Component({
  selector: 'wl-sc-progressive-form-container[rendering]',
  templateUrl: './sc-progressive-form-container.component.html',
  standalone: true,
  imports: [ProgressiveFormContainerComponent],
})
export class ScProgressiveFormContainerComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: TypedComponentRendering<ProgressiveFormContainerFields>;
  config?: ScDynamicProgressiveFormConfig;

  ngOnInit() {
    this.config = renderingMapper(this.rendering);
  }
}
